import { Tooltip } from "flowbite-react";
import { Link } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CheckIcon, DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";

const CopyLink = ({ url }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <div className="flex gap-1 items-center font-semibold text-base leading-normal">
      <Tooltip
        content={
          <Link target="_blank" to={url}>
            {url}
          </Link>
        }
      >
        <button type="button">
          <CopyToClipboard text={url} onCopy={handleCopy}>
            <div className="break-all text-left text-primary hover:text-primaryHover hover:underline">
              {url
                .replace("https://", "")
                .replace("http://", "")
                .replace("www.", "")}
            </div>
          </CopyToClipboard>
        </button>
      </Tooltip>

      <CopyToClipboard text={url} onCopy={handleCopy}>
        <button type="button">
          {isCopied ? (
            <CheckIcon className="size-5 text-green-500" />
          ) : (
            <DocumentDuplicateIcon className="size-5 text-primary hover:text-primaryHover" />
          )}
        </button>
      </CopyToClipboard>
    </div>
  );
};

export default CopyLink;
